module.exports = __webpack_public_path__ + "static/media/sample_code_upload.1e07e182.csv";